import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-support-button',
  templateUrl: './support-button.component.html',
  styleUrls: ['./support-button.component.scss']
})
export class SupportButtonComponent {
  timedOutCloser: any;
  targetMenuTrigger: any;

  isDropdownOpen = false;

  mouseEnter(trigger: any) {
    if (this.timedOutCloser) {
      clearTimeout(this.timedOutCloser);
    }
    trigger.openMenu();
  }

  mouseLeave(trigger: any, buttonElement: HTMLElement) {
    this.timedOutCloser = setTimeout(() => {
      trigger.closeMenu();
      buttonElement.blur(); // Clear focus to remove sticky hover background
    }, 50);
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const dropdownElement = (event.target as HTMLElement).closest('.position-relative');
    if (!dropdownElement) {
      this.isDropdownOpen = false;
    }
  }
}
